import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonLayoutComponent } from './pages/common-layout/common-layout/common-layout.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { PageNotFoundComponent } from './pages/login/page-not-found/page-not-found.component';
import { SwitchAcComponent } from './switch-ac/switch-ac.component';
import { SiteUnderMaintenanceComponent } from './site-under-maintenance/site-under-maintenance.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('../app/pages/login/login.module').then((m) => m.LoginModule),
    data: { title: 'Login' },
  },
  {
    path: 'switch-account',
    component: SwitchAcComponent,
  },
  {
    // User Profile / Security without a supplier, reached from the Switch Account user menu.
    path: 'account',
    loadChildren: () =>
      import('./account-shell/account-shell.module').then((m) => m.AccountShellModule),
  },
  {
    path: 'something-wrong',
    component: ErrorpageComponent,
  },
  {
    path: 'site-under-maintenance',
    component: SiteUnderMaintenanceComponent,
  },
  // { path: "common-layout", loadChildren: () => import('../app/pages/common-layout/common-layout.module').then(m => m.CommonLayoutModule), data: { title: "Common Layout" } },
  {
    path: 'supplier/:supplierId',
    component: CommonLayoutComponent,
    data: { title: '' },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/common-layout/common-layout.module').then(
            (m) => m.CommonLayoutModule
          ),
      },
    ],
    // resolve: { data: ExampleResolverService },
  },
  { path: 'page-not-found', component: PageNotFoundComponent },
  {
    path: '**',
    redirectTo: '/page-not-found',
    pathMatch: 'full',
    data: { title: 'Page Not Found' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
